import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AppSettings} from '../../config/config';
import {map} from 'rxjs/operators';

@Injectable()
export class SchoolRegistrationService {

  private URL = AppSettings.API_ENDPOINT;

  constructor(private http: HttpClient) {
  }

  // is valid url or its already existing
  isExcitingUrl(domain) {
    const params = {domainName: domain};
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    return this.http.post(this.URL + '/signUp/domainAvailability', params, {headers}).pipe(map(res => res));
  }


  // signUp/sendVerifyCode
  sendVerificationCode(domainName, emailId, username, phoneNumber) {
    const params = {domainName, emailId, username, phoneNumber};
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    return this.http.post(this.URL + '/signUp/sendVerifyCode', params, {headers}).pipe(map(res => res));
  }

  // register school with verification id
  registerSchool(domainName, schoolName, description, state, locality, pincode, address, accountType,
                 emailId, password, username, yourName, phoneNumber, otpVerificationCode, country) {
    const params = {
      domainName,
      schoolName,
      description,
      state,
      locality,
      pincode,
      address,
      accountType,
      emailId,
      password,
      username,
      yourName,
      phoneNumber,
      otpVerificationCode,
      country
    };
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    return this.http.post(this.URL + '/signUp/addSchool', params, {headers}).pipe(map(res => res));
  }

  // get school details with email id
  getSchoolWithEmail(emailId) {
    const params = {emailId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    return this.http.post(this.URL + '/signUp/findMyDomain', params, {headers}).pipe(map(res => res));
  }

}
